import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Modal from "../../components/modal";
import MDButton from "../../components/MDButton";
import { UnitChargeType } from "../../constants/unit_charge_types";
import { useEffect, useState } from "react";
import { UNIT_GAP, INITIAL_PRICE } from "../../constants/constants";

export default function AddChargeForm({ state, setState }) {
  const addType = state.addType;
  const title =
    state.addType === UnitChargeType.FIXED ? "Update fixed charges" : "Update per unit charges";
  const records =
    state.addType === UnitChargeType.FIXED ? state.fixedCharges : state.perUnitCharges;

  const [recordState, setRecordState] = useState({
    unitsFrom: addType == UnitChargeType.FIXED ? 0 : 1,
    price: 0,
  });

  useEffect(() => {
    const prev = records[records.length - 1];
    if (addType == UnitChargeType.FIXED) {
      setRecordState({
        unitsFrom: prev ? Number(prev.units_from) + UNIT_GAP + (records.length == 1 ? 1 : 0) : 0,
        price: prev ? Number(prev.price) : INITIAL_PRICE,
      });
    } else {
      setRecordState({
        unitsFrom: prev ? Number(prev.units_from) + UNIT_GAP : 1,
        price: prev ? Number(prev.price) : INITIAL_PRICE,
      });
    }
  }, [state.addType]);

  const onClose = () => {
    setState({ ...state, addType: null });
  };
  const onUpdate = async () => {
    if (state.addType === UnitChargeType.FIXED) {
      setState({
        ...state,
        addType: null,
        fixedCharges: [
          ...state.fixedCharges,
          {
            units_from: recordState.unitsFrom,
            price: recordState.price,
            type: UnitChargeType.FIXED,
          },
        ],
      });
    } else {
      setState({
        ...state,
        addType: null,
        perUnitCharges: [
          ...state.perUnitCharges,
          {
            units_from: recordState.unitsFrom,
            price: recordState.price,
            type: UnitChargeType.PER_UNIT,
          },
        ],
      });
    }
  };

  const onChangeUnitsFrom = (event) => {
    const unitsFrom = Number(event.target.value);
    if (records.length && unitsFrom > records[records.length - 1].units_from + 1) {
      setRecordState({ ...recordState, unitsFrom });
    }
  };

  const onChangePrice = (event) => {
    const price = Number(event.target.value);
    if (price >= 0) {
      setRecordState({ ...recordState, price });
    }
  };

  return addType ? (
    <Modal
      title={title}
      open={addType}
      actions={
        <MDBox display="flex" justifyContent="right" gap={1}>
          <MDButton onClick={onUpdate} variant="gradient" color="info">
            Done
          </MDButton>
          <MDButton onClick={onClose} variant="gradient" color="error">
            Cancel
          </MDButton>
        </MDBox>
      }
    >
      <MDBox component="form" role="form">
        <MDBox mb={2}>
          <MDInput
            type="number"
            label="From (Units)"
            fullWidth
            value={recordState.unitsFrom}
            disabled={!records.length}
            onChange={onChangeUnitsFrom}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="number"
            label="Price"
            fullWidth
            value={recordState.price}
            onChange={onChangePrice}
          />
        </MDBox>
      </MDBox>
    </Modal>
  ) : null;
}
